import { messages } from './messages';
import { todoCardIds, todoPageIds } from './todo-card-ids';
import {
  BASE_STORE_SETUP_URL,
  // BASE_PRODUCTS_PATH,
  BASE_ORDERS_PATH,
  BASE_SETTINGS_PATH,
  getCarriersPathForNegotiatedRates,
  getConnectSettingsPath,
  getInternationalSettingsPath,
  getInventorySyncSettingPath,
  getInventoryWarehousePath,
  getInventorySettingsPath,
  getPackagesSizeSettingsPath,
  getProductsInventoryPath,
  getPrintingSettingsPath,
  getRateShopperSettingsPath,
  // PRODUCT_BUNDLES_PATH,
  getFulfillmentProviderSettingsPath,
  getShipmentPickupsPath,
  WAREHOUSES_PATH,
  BASE_RETURNS_PATH,
  getSubscriptionPath,
  getAutomationsSettingsPath,
  getProductInventoryPath,
  getInsuranceSettingsPath,
} from '../../../../routes/constants';

export const todoCardData = [
  {
    id: todoCardIds.WAREHOUSE,
    title: messages.warehouseTitle,
    description: messages.warehouseDescription,
    linkText: messages.warehouseLinkText,
    link: getInventoryWarehousePath(),
    pageWhereRendered: todoPageIds.CONNECTED_SHIP_FROM_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.PICKUP,
    title: messages.pickupTitle,
    description: messages.pickupDescription,
    linkText: messages.pickupLinkText,
    link: getShipmentPickupsPath(),
    pageWhereRendered: todoPageIds.CONNECTED_SHIP_FROM_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.RATE_SHOPPING,
    title: messages.rateShoppingTitle,
    description: messages.rateShoppingDescription,
    linkText: messages.rateShoppingLinkText,
    link: getRateShopperSettingsPath(),
    pageWhereRendered: todoPageIds.AUTOMATION_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.CONNECT,
    title: messages.connectTitle,
    description: messages.connectDescription,
    linkText: messages.connectLinkText,
    link: getConnectSettingsPath(),
    pageWhereRendered: todoPageIds.AUTOMATION_PAGE,
    advancedOptionsTodo: true,
  },
  {
    id: todoCardIds.AUTOMATION_MORE_SETUP,
    title: messages.automationMoreSetupTitle,
    description: messages.automationMoreSetupDescription,
    linkText: messages.automationMoreSetupLinkText,
    link: getAutomationsSettingsPath(),
    pageWhereRendered: todoPageIds.DISCOUNTED_RATES_STEP,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.SETUP_INSURANCE,
    title: messages.setupInsuranceTitle,
    description: messages.setupInsuranceDescription,
    linkText: messages.setupInsuranceLinkText,
    link: getInsuranceSettingsPath(),
    pageWhereRendered: todoPageIds.DISCOUNTED_RATES_STEP,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.PHONE_NUMBER_CAPTURE,
    title: messages.phoneNumberCaptureTitle,
    description: messages.phoneNumberCaptureDescription,
    linkText: messages.phoneNumberCaptureLinkText,
    pageWhereRendered: todoPageIds.CONNECTED_SHIP_FROM_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.NEGOTIATED_CARRIER,
    title: messages.negotiatedCarrierTitle,
    description: messages.negotiatedCarrierDescription,
    linkText: messages.negotiatedCarrierLinkText,
    link: getCarriersPathForNegotiatedRates(),
    pageWhereRendered: todoPageIds.CARRIERS_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.INTERNATIONAL,
    title: messages.internationalTitle,
    description: messages.internationalDescription,
    linkText: messages.internationalLinkText,
    link: getInternationalSettingsPath(),
    pageWhereRendered: todoPageIds.CARRIERS_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.LABEL_LAYOUT,
    title: messages.labelLayoutTitle,
    description: messages.labelLayoutDescription,
    linkText: messages.labelLayoutLinkText,
    link: getPrintingSettingsPath(),
    pageWhereRendered: todoPageIds.ADVANCED_OPTIONS_PAGE,
    advancedOptionsTodo: true,
  },
  {
    id: todoCardIds.BRANDED_TRACKING,
    title: messages.brandedTrackingTitle,
    description: messages.brandedTrackingDescription,
    linkText: messages.brandedTrackingLinkText,
    link: BASE_STORE_SETUP_URL,
    pageWhereRendered: todoPageIds.ADVANCED_OPTIONS_PAGE,
    advancedOptionsTodo: true,
  },
  {
    id: todoCardIds.PACKAGE_SIZES,
    title: messages.packageSizesTitle,
    description: messages.packageSizesDescription,
    linkText: messages.packageSizesLinkText,
    link: getPackagesSizeSettingsPath(),
    pageWhereRendered: todoPageIds.ADVANCED_OPTIONS_PAGE,
    advancedOptionsTodo: true,
  },
  {
    id: todoCardIds.PACKING_SLIPS,
    title: messages.packingSlipsTitle,
    description: messages.packingSlipsDescription,
    linkText: messages.packingSlipsLinkText,
    link: getPrintingSettingsPath(),
    pageWhereRendered: todoPageIds.ADVANCED_OPTIONS_PAGE,
    advancedOptionsTodo: true,
  },
  {
    id: todoCardIds.FULFILLMENT,
    title: messages.fulfillmentTitle,
    description: messages.fulfillmentDescription,
    linkText: messages.fulfillmentLinkText,
    link: getFulfillmentProviderSettingsPath(),
    pageWhereRendered: todoPageIds.ADVANCED_OPTIONS_PAGE,
    advancedOptionsTodo: true,
  },
  {
    id: todoCardIds.INVENTORY_SYNC,
    title: messages.inventorySyncTitle,
    description: messages.inventorySyncDescription,
    linkText: messages.inventorySyncLinkText,
    link: getInventorySyncSettingPath(),
    pageWhereRendered: todoPageIds.INVENTORY_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.SHIPSTATION_INVENTORY,
    title: messages.shipstationInventoryTitle,
    description: messages.shipstationInventoryDescription,
    linkText: messages.shipstationInventoryLinkText,
    link: getInventorySettingsPath(),
    pageWhereRendered: todoPageIds.INVENTORY_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.REORDERING,
    title: messages.reorderingTitle,
    description: messages.reorderingDescription,
    linkText: messages.reorderingLinkText,
    link: getProductInventoryPath(),
    pageWhereRendered: todoPageIds.INVENTORY_PAGE,
    advancedOptionsTodo: false,
  },
  // {
  //   id: todoCardIds.AUTO_ROUTING,
  //   title: messages.autoRoutingTitle,
  //   description: messages.autoRoutingDescription,
  //   linkText: messages.autoRoutingLinkText,
  //   link: '/',
  //   pageWhereRendered: todoPageIds.INVENTORY_PAGE,
  //   advancedOptionsTodo: false,
  // },
  // {
  //   id: todoCardIds.BUNDLES,
  //   title: messages.bundlesTitle,
  //   description: messages.bundlesDescription,
  //   linkText: messages.bundlesLinkText,
  //   link: PRODUCT_BUNDLES_PATH,
  //   pageWhereRendered: todoPageIds.INVENTORY_PAGE,
  //   advancedOptionsTodo: false,
  // },
  {
    id: todoCardIds.LOT_TRACKING,
    title: messages.lotTrackingTitle,
    description: messages.lotTrackingDescription,
    linkText: messages.lotTrackingLinkText,
    link: getProductInventoryPath(),
    pageWhereRendered: todoPageIds.INVENTORY_PAGE,
    advancedOptionsTodo: false,
  },
  // {
  //   id: todoCardIds.UPLOAD_PRODUCTS,
  //   title: messages.uploadProductsTitle,
  //   description: messages.uploadProductsDescription,
  //   linkText: messages.uploadProductsLinkText,
  //   link: BASE_PRODUCTS_PATH,
  //   pageWhereRendered: todoPageIds.INVENTORY_PAGE,
  //   advancedOptionsTodo: false,
  // },
  {
    id: todoCardIds.ACCOUNT_USERS,
    title: messages.accountUsersTitle,
    description: messages.accountUsersDescription,
    linkText: messages.accountUsersLinkText,
    link: `${BASE_SETTINGS_PATH}/users`,
    pageWhereRendered: todoPageIds.ADVANCED_OPTIONS_PAGE,
    advancedOptionsTodo: true,
  },
  {
    id: todoCardIds.DEMO_ORDER,
    title: messages.demoOrderTitle,
    description: messages.demoOrderDescription,
    linkText: messages.demoOrderLinkText,
    link: BASE_ORDERS_PATH,
    pageWhereRendered: todoPageIds.AUTOMATION_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.GET_STARTED_WEBINAR,
    title: messages.getStartedWebinarTitle,
    description: messages.getStartedWebinarDescription,
    linkText: messages.learnMore,
    link: 'https://www.shipstation.com/webinars/get-started-with-shipstation/',
    pageWhereRendered: todoPageIds.AUTOMATION_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.ACCOUNT_OPTIMIZATION_WEBINAR,
    title: messages.accountOptimizationWebinarTitle,
    description: messages.accountOptimizationWebinarDescription,
    linkText: messages.learnMore,
    link: 'https://www.shipstation.com/webinars/account-optimization/',
    pageWhereRendered: todoPageIds.AUTOMATION_PAGE,
    advancedOptionsTodo: false,
  },
  // {
  //   id: todoCardIds.API,
  //   title: messages.apiTitle,
  //   description: messages.apiDescription,
  //   linkText: messages.apiLinkText,
  //   link: '/',
  //   pageWhereRendered: todoPageIds.INVENTORY_PAGE,
  //   advancedOptionsTodo: false,
  // },
  {
    id: todoCardIds.BRANDED_RETURNS,
    title: messages.brandedReturnsTitle,
    description: messages.brandedReturnsDescription,
    linkText: messages.brandedReturnsLinkText,
    link: BASE_STORE_SETUP_URL,
    pageWhereRendered: todoPageIds.RETURNS_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.RETURNS_URL,
    title: messages.returnsUrlTitle,
    description: messages.returnsUrlDescription,
    linkText: messages.returnsUrlLinkText,
    link: BASE_STORE_SETUP_URL,
    pageWhereRendered: todoPageIds.RETURNS_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.RETURNS_HELP,
    title: messages.returnsHelpTitle,
    description: messages.returnsHelpDescription,
    linkText: messages.returnsHelpLinkText,
    link: BASE_STORE_SETUP_URL,
    pageWhereRendered: todoPageIds.RETURNS_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.SHOPIFY_RETURNS,
    title: messages.shopifyTodoTitle,
    description: messages.shopifyTodoDescription,
    linkText: messages.brandedReturnsLinkText,
    link: BASE_STORE_SETUP_URL,
    pageWhereRendered: todoPageIds.RETURNS_PAGE,
  },
  // Freemium todos
  {
    id: todoCardIds.FREEMIUM_CONNECT_STORE,
    title: messages.freemiumConnectStoreTitle,
    description: messages.freemiumConnectStoreDescription,
    linkText: messages.freemiumConnectStoreLinkText,
    link: BASE_STORE_SETUP_URL,
    pageWhereRendered: todoPageIds.AUTOMATION_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.FREEMIUM_ADD_SHIP_FROM_ADDRESS,
    title: messages.freemiumAddShipFromAddressTitle,
    description: messages.freemiumAddShipFromAddressDescription,
    linkText: messages.freemiumAddShipFromAddressLinkText,
    link: WAREHOUSES_PATH,
    pageWhereRendered: todoPageIds.AUTOMATION_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.FREEMIUM_ADD_PAYMENT_METHOD,
    title: messages.freemiumAddPaymentMethodTitle,
    description: messages.freemiumAddPaymentMethodDescription,
    linkText: messages.freemiumAddPaymentMethodLinkText,
    link: getSubscriptionPath(),
    pageWhereRendered: todoPageIds.AUTOMATION_PAGE,
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.FREEMIUM_CONNECT,
    title: messages.freemiumConnectTitle,
    description: messages.freemiumConnectDescription,
    linkText: messages.freemiumConnectLinkText,
    link: getConnectSettingsPath(),
    pageWhereRendered: 'freemium_page',
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.FREEMIUM_SHIPSTATION_101,
    title: messages.freemiumShipstation101Title,
    description: messages.freemiumShipstation101Description,
    linkText: messages.freemiumShipstation101LinkText,
    link: 'https://help.shipstation.com',
    pageWhereRendered: 'freemium_page',
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.FREEMIUM_RATE_SHOPPING,
    title: messages.freemiumRateShoppingTitle,
    description: messages.freemiumRateShoppingDescription,
    linkText: messages.freemiumRateShoppingLinkText,
    link: getRateShopperSettingsPath(),
    pageWhereRendered: 'freemium_page',
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.FREEMIUM_LABEL_LAYOUT,
    title: messages.freemiumLabelLayoutTitle,
    description: messages.freemiumLabelLayoutDescription,
    linkText: messages.freemiumLabelLayoutLinkText,
    link: getPrintingSettingsPath(),
    pageWhereRendered: 'freemium_page',
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.FREEMIUM_CREATE_RETURN_LABEL,
    title: messages.freemiumCreateReturnLabelTitle,
    description: messages.freemiumCreateReturnLabelDescription,
    linkText: messages.freemiumCreateReturnLabelLinkText,
    link: BASE_RETURNS_PATH,
    pageWhereRendered: 'freemium_page',
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.IMPORT_PRODUCTS,
    title: messages.freemiumImportProductsTitle,
    description: messages.freemiumImportProductsDescription,
    linkText: messages.freemiumImportProductsLinkText,
    link: getProductsInventoryPath(),
    pageWhereRendered: 'freemium_page',
    advancedOptionsTodo: false,
  },
  {
    id: todoCardIds.SETUP_RETURNS,
    title: messages.freemiumSetupReturnsTitle,
    description: messages.freemiumSetupReturnsDescription,
    linkText: messages.freemiumSetupReturnsLinkText,
    link: BASE_STORE_SETUP_URL,
    pageWhereRendered: 'freemium_page',
    advancedOptionsTodo: false,
  },
];
